// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HUbo2","contentBox":"Header_contentBox__YVAzG","itemForm":"Header_itemForm__nKDHt"};